module.exports = __webpack_public_path__ + "img/img_contribution_thumb.541d5e03.png";